var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 118,
    viewBox: "0 0 121 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inst"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "text",
    x: 1,
    y: 1,
    width: 115,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "text_2",
    x: 5,
    y: 2,
    width: 115,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 42.5833C26 32.3259 34.369 24 44.7059 24H72.2941C82.631 24 91 32.3259 91 42.5833V71.4167C91 81.6741 82.631 90 72.2941 90H44.7059C34.369 90 26 81.6741 26 71.4167V42.5833Z",
    stroke: "#11141D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.8692 57.389C77.8692 66.3683 70.5436 73.6528 61.5004 73.6528C52.4572 73.6528 45.1316 66.3683 45.1316 57.389C45.1316 48.4096 52.4572 41.1251 61.5004 41.1251C70.5436 41.1251 77.8692 48.4096 77.8692 57.389ZM61.5004 74.6528C71.09 74.6528 78.8692 66.9265 78.8692 57.389C78.8692 47.8514 71.09 40.1251 61.5004 40.1251C51.9108 40.1251 44.1316 47.8514 44.1316 57.389C44.1316 66.9265 51.9108 74.6528 61.5004 74.6528ZM47.7059 23.5H75.2941C85.9042 23.5 94.5 32.0468 94.5 42.5833V71.4167C94.5 81.9532 85.9042 90.5 75.2941 90.5H47.7059C37.0958 90.5 28.5 81.9532 28.5 71.4167V42.5833C28.5 32.0468 37.0958 23.5 47.7059 23.5ZM78.3692 57.389C78.3692 66.6474 70.8168 74.1528 61.5004 74.1528C52.184 74.1528 44.6316 66.6474 44.6316 57.389C44.6316 48.1305 52.184 40.6251 61.5004 40.6251C70.8168 40.6251 78.3692 48.1305 78.3692 57.389Z",
    stroke: "#11141D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.fe3d4af7703dc9b6eb37a595b51f5e67.svg";
export { ForwardRef as ReactComponent };